import React, { createElement } from 'react'

import camelCase from 'camelcase'

const walkChildren = children => {
  return children.map((child, idx) => {
    const { name, attribs: attribsMap, children: gchildren = null } = child

    //fill, stroke
    const attribs = Object.keys(attribsMap)
      .filter(
        key => key !== 'fill' && key !== 'stroke' && attribsMap[key] !== 'none',
      )
      .reduce((partial, key) => {
        partial[camelCase(key)] = attribsMap[key]
        return partial
      }, {})
    //special case, it has fill and stroke at the same time
    let merge = {}
    if (attribsMap.fill === 'none' && attribsMap.stroke) {
      merge = { fill: 'none', stroke: 'currentColor' }
    }
    return createElement(
      name,
      { key: idx, ...attribs, ...merge },
      gchildren === null ? gchildren : walkChildren(gchildren),
    )
  })
}

export const SvgIcon = props => {
  const { icon, g = false, ...rest } = props
  const { children, viewBox } = icon
  if (g) {
    // used for downloadable storybook svg sheet
    const gProps = {
      id: props.title,
      transform: props.transform,
    }
    return (
      <g {...gProps}>
        {props.title ? <title>{props.title}</title> : null}
        <rect height="24" width="24" className="bg" />
        {walkChildren(children)}
      </g>
    )
  }

  return (
    <svg viewBox={viewBox} {...rest}>
      {props.title ? <title>{props.title}</title> : null}
      {walkChildren(children)}
    </svg>
  )
}
